import { useRoutes } from "react-router-dom";
import MainRoutes from "./main-routes";
import SMSResellerPlatform from "../views/marketing-pages/add-reseller";
import Login from "../views/auth/login";
import ForgotPassword from "../views/auth/forgot-password";
import Landing from "./landing";
import CreateAccount from "../views/auth/create-account";
import VerifyAccount from "../views/auth/verify";
import CreateProfile from "../views/auth/create-profile";
import ResetPassword from "../views/auth/reset-password";
import VerifyResetPassword from "../views/auth/verify-reset-password";
import AcceptInvite from "../views/auth/accept-invite";
import { GoogleOAuthProvider } from '@react-oauth/google';
import Subscription from "../unsubscribe";
import NotFound from "../views/error-pages/not-found";
// ================|| ROUTING RENDER ||================ //

export default function ThemeRoutes() {
  return useRoutes([
    Landing,
    ...MainRoutes,
    { path: "/login", element: 
      <GoogleOAuthProvider clientId="354372594070-mlstjmuk2qie7qqiqfdaoullkkacss1l.apps.googleusercontent.com">
      <Login />
      </GoogleOAuthProvider>
     },
    { path: "/create-account", element: 
      <GoogleOAuthProvider clientId="354372594070-mlstjmuk2qie7qqiqfdaoullkkacss1l.apps.googleusercontent.com">
    <CreateAccount />
   </GoogleOAuthProvider> },
    { path: "/verify", element: <VerifyAccount /> },
    { path: "/reset-verification", element: <VerifyResetPassword /> },
    { path: "/postsignup", element: <CreateProfile /> },
    { path: "/forgot-password", element: <ForgotPassword /> },
    { path: "/reset-password", element: <ResetPassword /> },
    { path: "/accept-invite", element: <AcceptInvite /> },
    { path: "/add-reseller", element: <SMSResellerPlatform /> },
    { path: "/subscription", element: <Subscription /> },
    { path: "*", element: <NotFound /> },

  ]);
}
